// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Counterparty': 'Контрагент',
  'Counterparties': 'Контрагенти',
  'Duplicate': 'Дублювати',

  'Field_Note': 'Примітка',
  'Total': 'Сума',
};
